import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "hubConversionData",
  initialState: { hubs: [], sortMetricsByTeamId: {} },
  reducers: {
    
    // we do this all in one reducer to avoid state updates
    hubConversionDataInitialised: (state, action) => {
      action.payload.data.forEach(hubData => {

        state.hubs.push( {id: hubData.Id, metrics: []} );

        hubData.MetricsData.forEach(metricData => {
          
          let timePeriods = [];
          metricData.TimePeriodData.forEach(o => {
            timePeriods.push( {
              period: o.Period,
              value: o.FormattedValue,
              valueNumeric: o.Value ?? 0,
              trend: o.Trend,
              previousPeriodText: o.PreviousPeriodText,
              targetText: o.TargetText ?? null,
              target: o.Target ?? null
            });
          });

          const hub = state.hubs.find(o => o.id == hubData.Id);
          hub.metrics.push( { id: metricData.Id, timePeriods: timePeriods } );
        
        });

      });
    },

    teamConversionSortMetricsInitialised: (state, action) => {
      const next = {};
      action.payload.data.forEach((row) => {
        next[row.TeamId] = {
          primarySortMetricId: row.PrimarySortMetricId ?? null,
          secondarySortMetricId: row.SecondarySortMetricId ?? null,
        };
      });
      state.sortMetricsByTeamId = next;
    },

    hubMetricValuesUpdated: (state, action) => {

      const hub = state.hubs.find(o => o.id == action.payload.data.Id);
      if (!hub) return;
      
      action.payload.data.MetricsData.forEach(metricData => {
        const metric = hub.metrics.find(o => o.id === metricData.Id);
        if (metric) {
          metricData.TimePeriodData.forEach(o => {
            const timePeriod = metric.timePeriods.find(tp => tp.period === o.Period);
            if (timePeriod) {
              timePeriod.value = o.FormattedValue;
              timePeriod.valueNumeric = o.Value ?? 0;
              timePeriod.trend = o.Trend;
              timePeriod.previousPeriodText = o.PreviousPeriodText;
              timePeriod.targetText = o.TargetText ?? null;
              timePeriod.target = o.Target ?? null;
            }
          });
        }        
      });

    },

  },
});

export const {
  hubConversionDataInitialised,
  hubMetricValuesUpdated,
  teamConversionSortMetricsInitialised,
} = slice.actions;
export default slice.reducer;

function getMetricIdAndValue(state, hubId, period, index) {
  if (!period) return null;

  const hub = state.hubs.find(hub => hub.id === hubId);
  if (!hub) return null;
  
  if (index >= hub.metrics.length) return null;

  let metricId = null;
  let value = null;
  let valueNumeric = null;
  let trend = null;
  let previousPeriodText = null;
  let targetText = null;
  let target = null;

  hub.metrics[index].timePeriods.forEach(o => {
    if (o.period === period) {
      metricId = hub.metrics[index].id;
      value = o.value;
      valueNumeric = o.valueNumeric;
      trend = o.trend;
      previousPeriodText = o.previousPeriodText;
      targetText = o.targetText;
      target = o.target;
    }
  });

  if (metricId)  {
    return { id: metricId, value, valueNumeric, trend, previousPeriodText, targetText, target };
  }
  else {
    return null;
  }

}

export const getMetric1IdAndValue = (state, hubId, period) => 
{
  return getMetricIdAndValue(state, hubId, period, 0);
}

export const getMetric2IdAndValue = (state, hubId, period) => 
{
  return getMetricIdAndValue(state, hubId, period, 1);
}

/** @returns {{ primarySortMetricId: number|null, secondarySortMetricId: number|null } | undefined} */
export function getTeamSortMetricIds(state, teamId) {
  return state.sortMetricsByTeamId[teamId];
}

/** True if this team has hub conversion data from gethubdata (metrics for the hub). */
export function teamHasHubConversionEntry(state, teamId) {
  return state.hubs.some((h) => h.id == teamId);
}
